import { render, staticRenderFns } from "./booking-event-payment-follow-up.vue?vue&type=template&id=063ffe8d&"
import script from "./booking-event-payment-follow-up.vue?vue&type=script&lang=ts&"
export * from "./booking-event-payment-follow-up.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports